import handleError from '../../../utils/handleError';
import { Client } from 'client-sdk/src';
import {GetVehicleEntrancesRequestBuilder} from "client-sdk/src/entrances/getEntrances";
// export default const getDrivers = () => {

// }

const token = localStorage.getItem('token');

export async function getVehiclesEntrances(statusFilters: any) {
    try {
        const getEntrances = new GetVehicleEntrancesRequestBuilder()
        .params(statusFilters)
        .build();
        const client = new Client(token as string);
        const response = client.execute(
        getEntrances,
        );
        return response;
      } catch (error) {
          return handleError(error.response);
        }
  }

export default getVehiclesEntrances;
